import React, {useState} from 'react'
import {
  GlobalStyle,
  ImgCont,
  Wrapper,
  NewsletterButton,
  TicketsButton
} from './styles'
import Header from './components/Header'
import Footer from './components/Footer'
import ImgBox from './components/ImgBox'
import ColorPicker from './components/ColorPicker'
import Modal from './components/Modal'
import NewsletterModalInner from './components/NewsletterModalInner'
import TicketsModalInner from './components/TicketsModalInner'

// prettier-ignore
const matrix = [
  [0,0], [1,0], [2,0], [3,0], [4,0], [5,0],
  [0,1], [1,1], [2,1], [3,1], [4,1], [5,1],
  [0,2], [1,2], [2,2], [3,2], [4,2], [5,2],
  [0,3], [1,3], [2,3], [3,3], [4,3], [5,3],
  [0,4], [1,4], [2,4], [3,4], [4,4], [5,4],
  [0,5], [1,5], [2,5], [3,5], [4,5], [5,5],
  [0,6], [1,6], [2,6], [3,6], [4,6], [5,6],
  [0,7], [1,7], [2,7], [3,7], [4,7], [5,7],
]

const App = () => {
  const [distance, setDistance] = useState(1)

  const [showNewsletterModal, setShowNewsletterModal] = useState(false)
  const [showTicketsModal, setShowTicketsModal] = useState(false)

  const easing = (num) => Math.pow(num, 3)

  const calculateDistance = ([x, y]) => {
    const center = [window.innerWidth / 2, window.innerHeight / 2]
    const maxHypot = Math.hypot(center[0], center[1])
    const hypot = Math.hypot(center[0] - x, center[1] - y)
    const distance = hypot / maxHypot
    const easeDistance = easing(distance)
    setDistance(easeDistance)
  }

  const handleMove = ({clientX, clientY}) => {
    calculateDistance([clientX, clientY])
  }

  const handleTouchMove = ({touches}) => {
    calculateDistance([touches[0].clientX, touches[0].clientY])
  }

  const [bgColor, setBgColor] = useState('#0519ce')
  const [textColor, setTextColor] = useState('#fbfbfb')

  const toggleNewsletterModal = () => {
    setShowNewsletterModal((showNewsletterModal) => !showNewsletterModal)
  }
  const toggleTicketsModal = () => {
    setShowTicketsModal((showTicketsModal) => !showTicketsModal)
  }

  const [numberTickets, setNumberTickets] = useState(1)

  return (
    <>
      <GlobalStyle />

      {showNewsletterModal && (
        <Modal
          toggleModal={toggleNewsletterModal}
          textColor={textColor}
          bgColor={bgColor}
        >
          <NewsletterModalInner textColor={textColor} bgColor={bgColor} />
        </Modal>
      )}

      {showTicketsModal && (
        <Modal
          toggleModal={toggleTicketsModal}
          textColor={textColor}
          bgColor={bgColor}
        >
          <TicketsModalInner
            textColor={textColor}
            bgColor={bgColor}
            numberTickets={numberTickets}
            setNumberTickets={setNumberTickets}
          />
        </Modal>
      )}

      <Header textColor={textColor} />
      <Footer textColor={textColor} />
      <ColorPicker
        bgColor={bgColor}
        setBgColor={setBgColor}
        textColor={textColor}
        setTextColor={setTextColor}
      />

      <Wrapper
        onMouseMove={handleMove}
        onTouchMove={handleTouchMove}
        $color={bgColor}
      >
        <ImgCont $isTogether={distance < 0.001}>
          <NewsletterButton
            onClick={toggleNewsletterModal}
            $textColor={textColor}
            $bgColor={bgColor}
          >
            Sign up for updates
          </NewsletterButton>

          <TicketsButton
            onClick={toggleTicketsModal}
            $textColor={textColor}
            $bgColor={bgColor}
          >
            Buy Tickets
          </TicketsButton>

          {matrix.map(([x, y], index) => (
            <ImgBox key={index} x={x} y={y} percent={distance} />
          ))}
        </ImgCont>
      </Wrapper>
    </>
  )
}

export default App
